import React, { useEffect, useRef } from 'react';
import classes from './CustomTabSwitcher.module.scss';

const CustomTabSwitcher = ({ tabList, activeTab, setActiveTab }) => {
    const tabRefs = useRef({});
    const sliderRef = useRef();

    useEffect(() => {
        const currentTab = tabRefs.current[activeTab];
        const slider = sliderRef.current;

        if (currentTab && slider) {
            const { offsetLeft, offsetWidth } = currentTab;
            slider.style.left = `${offsetLeft}px`;
            slider.style.width = `${offsetWidth}px`;
        }
    }, [activeTab, tabList]);

    return (
        <div className={classes.CustomTabSwitcher}>
            <div className={classes.CustomTabSwitcher__Buttons}>
                <div ref={sliderRef} className={classes.CustomTabSwitcher__Slider}></div>
                {tabList.map((tab) => (
                    <button
                        key={tab}
                        ref={(el) => (tabRefs.current[tab] = el)}
                        className={`${classes.CustomTabSwitcher__Button} ${activeTab === tab ? classes['CustomTabSwitcher__Button--active'] : ''
                            }`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default CustomTabSwitcher;
